export default __webpack_public_path__ + "static/blob-28-89b8bcd6de37a604e11dd9b2e9f59086.svg";